import React from 'react';

export default function PartnerJourneyStep({
  number,
  eyebrow,
  title,
  description,
  children,
  isLast = false,
}) {
  return (
    <section className="relative grid gap-6 md:grid-cols-[5rem_1fr] md:gap-8">
      <div className="relative flex md:justify-center">
        <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#409FA1] bg-[#F7F8F7] font-michroma text-xs font-bold text-[#244A49]">
          {number}
        </span>
        {!isLast && (
          <span
            className="absolute left-6 top-12 h-[calc(100%+1.5rem)] w-px bg-[#409FA1]/25 md:left-1/2 md:-translate-x-1/2"
            aria-hidden="true"
          />
        )}
      </div>

      <div className={isLast ? '' : 'pb-16 md:pb-20'}>
        <p className="font-michroma text-[0.65rem] font-bold uppercase tracking-[0.18em] text-[#409FA1]">
          {eyebrow}
        </p>
        <h2 className="mt-3 text-2xl font-bold tracking-tight text-[#101F1F] sm:text-3xl">
          {title}
        </h2>
        <p className="mt-4 max-w-3xl text-base leading-7 text-[#244A49]/70 sm:text-lg sm:leading-8">
          {description}
        </p>
        <div className="mt-8">{children}</div>
      </div>
    </section>
  );
}